export var transformResponseToFormState = function (data) { return ({
    timezone: data.system_timezone.timezone,
}); };
